// 모달 크기 커스텀 API 클라이언트 — /api/v2/me/modal-prefs
//
// 로그인 계정마다 각 모달을 늘려/줄여 저장한 px 를 읽고 쓴다. 인증·에러 처리는 공통 _client.
// 저장 단위는 modalKey(ModalShell 의 resizeKey) 1개당 { width?, height? } 한 줄.

import { authJson } from "./_client";

const API = `${import.meta.env.VITE_API_BASE_URL ?? ""}/api/v2/me`;

export interface ModalSizePref {
  width?: number;
  height?: number;
}

/** 내 모달 크기 전체를 { "<modalKey>": { width?, height? } } 맵으로. 비로그인/없으면 {}. */
export async function fetchAllModalPrefs(): Promise<Record<string, ModalSizePref>> {
  const res = await authJson<{ prefs: Record<string, ModalSizePref> }>(`${API}/modal-prefs`);
  return res.prefs ?? {};
}

/** 모달 크기 저장(upsert). 빈 dim 을 보내면 서버가 그 모달 설정을 지워 기본 크기로 되돌린다. */
export async function saveModalPref(key: string, dim: ModalSizePref): Promise<ModalSizePref | null> {
  const res = await authJson<{ ok: boolean; config: ModalSizePref | null }>(
    `${API}/modal-prefs/${encodeURIComponent(key)}`,
    { method: "PUT", body: JSON.stringify(dim) },
  );
  return res.config;
}

/** 모달 크기 초기화(원래대로). */
export async function deleteModalPref(key: string): Promise<void> {
  await authJson(`${API}/modal-prefs/${encodeURIComponent(key)}`, { method: "DELETE" });
}
